<template>
    <div class="flex flex-col items-center justify-center">
        <NuxtLink to="/" class="mt-4">
            <NuxtImg
                src="/kolayesim-logo.svg"
                alt="Kolay Esim Logo"
                width="250" />
        </NuxtLink>
    </div>
    <div
        class="lg:px-24 lg:py-24 md:py-20 md:px-44 px-4 py-24 items-center flex justify-center flex-col lg:flex-row">
        <div class="xl:w-1/2 pb-12 lg:pb-0">
            <h1 class="my-2 text-san-marino-800 font-bold text-3xl">
                Üzgünüz! Aradığınız sayfayı bulamadık.
            </h1>
            <p class="my-2 text-san-marino-800 text-xl">
                Ancak sizin için 200'den fazla ülke ve bölgede geçerli veri
                paketleri bulabiliriz.
            </p>
            <button
                class="sm:w-full lg:w-auto my-2 border rounded md py-4 px-8 text-center bg-san-marino-600 text-white hover:bg-san-marino-700 focus:outline-none focus:ring-2 focus:ring-san-marino-700 focus:ring-opacity-50"
                @click="$router.push('/')">
                Hemen Görüntüle
            </button>
        </div>
        <div>
            <NuxtImg src="/error.jpg" alt="Error the page not found" loading="lazy" width="600" />
        </div>
    </div>
</template>

<script setup>
useHead({
    title: "Üzgünüz! Aradığınız Sayfa Bulunamadı",
    meta: [
        {
            name: "description",
            content: "Üzgünüz! Aradığınız sayfa bulunamadı.",
        },
    ],
});
</script>
